<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    :class="traderMode == true ? 'trader-bg' : 'user-bg'"
    app
    dark
    floating
    persistent
    mobile-breakpoint="1367"
    width="268"
  >
    <upgrade-from-free
      v-if="upgradeDialog"
      :show-dialog="upgradeDialog"
      @closeUpgradeDialog="closeUpgradeDialog"
    />
    <v-layout column>
      <v-img
        :src="logo"
        :lazy-src="logo"
        alt="AIVIA"
        max-height="85"
        contain
      />
      <v-divider />
      <v-list-item
        v-for="(link, i) in links"
        v-show="link.traderMode == undefined || link.traderMode == traderMode"
        :key="i"
        :to="link.to"
        class="v-list-item"
      >
        <v-list-item-action>
          <component
            :is="link.icon"
            style="width:25px;"
          />
        </v-list-item-action>
        <v-list-item-title v-text="link.text" />
        <v-badge
          v-if="link.to == '/investors' && pendingRequests > 0"
          color="primary"
        >
          <template v-slot:badge>
            <span :title="$t('drawer.pending')">{{ pendingRequests }}</span>
          </template>
        </v-badge>
      </v-list-item>
    </v-layout>
    <v-divider class="mt-6" />
    <!-- <v-layout
      v-if="getUser && !getUser.pack && !getTraderMode"
      wrap
      mt-8
    >
      <v-flex
        ml-9
        mr-9
      >
        <small
          style="color:white; font-size:13px;"
        >
          {{ $t("toolbar.yourPackage") }}: <b>Qualified</b>
        </small>
        <br> 
        <v-btn
      
          class="success mt-2"
          outlined
          text
          small
          block
          @click="$router.push('/subscriptions')"
        >
          {{ $t('toolbar.buyPackage') }}
        </v-btn>
      </v-flex>
    </v-layout> -->
   
    <v-layout column>
      <v-btn
        style="position:absolute;color:white;left:35px;"
        :style="$vuetify.breakpoint.xs ? 'bottom:90px;': 'bottom:70px;'"
        outlined
        text
        small
        @click="needHelp"
      >
        {{ $t('drawer.needHelp') }}
      </v-btn>
      <v-list-item
        v-if="auth"
        style="position:absolute;"
        :style="$vuetify.breakpoint.xs ? 'bottom:40px;': 'bottom:10px;'"
      >
        <v-list-item-action>
          <v-switch
            v-model="traderMode"
          />
        </v-list-item-action>
        <v-list-item-title class="font-weight-medium">
          <small>
            {{ $t('drawer.tMode') }}
            <b>{{ getTraderMode == true ? $t('drawer.on') : $t('drawer.off') }}</b>
          </small>
        </v-list-item-title>
      </v-list-item>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState, mapGetters } from "vuex";
import IconDashboard from "@/components/icons/IconDashboard.vue";
import IconFunds from "@/components/icons/IconRating.vue";
import IconBots from "@/components/icons/IconBots.vue";
import IconMyBots from "@/components/icons/IconMyBots.vue";
import IconPortfolio from "@/components/icons/IconPortfolio.vue";
import IconPoject from "@/components/icons/IconProject.vue";
import IconWallet from "@/components/icons/IconWallet.vue";
import IconCalc from "@/components/icons/IconCalc.vue";
import IconInvoice from "@/components/icons/IconInvoice.vue";
import IconBtc from "@/components/icons/IconBtc.vue";
import UpgradeFromFree from "@/views/Packs/partial/UpgradeFromFree.vue"


const PENDING_CONNECTION_QUERY = require("@/graphql/queries/PendingConnection.gql");

export default {
  components: {
    UpgradeFromFree
  },
  data() {
    return {
      needHelpDialog: false,
      auth: localStorage.getItem("auth-token") !== null,
      pendingConnections: null,
      logo: require("@/images/logo.png"),
      upgradeDialog: false,
      links: [
        {
          to: "/dashboard",
          icon: IconDashboard,
          text: this.$i18n.t("drawer.dashboard"),
          traderMode: false
        },
        {
          to: "/trader/dashboard",
          icon: IconDashboard,
          text: this.$i18n.t("drawer.dashboard"),
          traderMode: true
        },
        {
          to: "/rankings",
          icon: IconFunds,
          text: this.$t("drawer.topFunds"),
        },
        // {
        //   to: "/bots",
        //   icon: IconBots,
        //   text: this.$t("drawer.bots"),
        //   traderMode: false
        // },
        // {
        //   to: "/traderbots",
        //   icon: IconMyBots,
        //   text: this.$t("drawer.myBots"),
        //   traderMode: true
        // },
        {
          to: "/accounts",
          icon: IconWallet,
          text: this.$t("drawer.myAccounts"),
          traderMode: false
        },
        {
          to: "/calculator",
          icon: IconCalc,
          text: this.$t("drawer.roiCalc"),
          traderMode: false
        },
        {
          to: "/projects",
          icon: IconPoject,
          text: this.$t("drawer.myProjects"),
          traderMode: true
        },
        {
          to: "/investors",
          icon: IconPortfolio,
          text: this.$t("drawer.myInvestors"),
          traderMode: true
        },
        {
          to: "/buycrypto",
          icon: IconBtc,
          text: this.$t("drawer.buyCrypto")
        }
      ],
      responsive: false
    };
  },
  apollo: {
    pendingConnections: {
      query() {
        return PENDING_CONNECTION_QUERY;
      },
      result({ data, loading, networkStatus }) {
        if (loading == false && data.pendingConnections !== null) {
          this.setPendingRequests(data.pendingConnections.count);
        }
      },
      skip() {
        return (
          this.traderMode == false || localStorage.getItem("auth-token") == null
        );
      },
      fetchPolicy: "network"
    }
  },
  computed: {
    ...mapState("app", ["image", "color", "pendingRequests"]),
    ...mapGetters("app", ["getTraderMode"]),
    ...mapGetters("user", ["getUser"]),
    traderMode: {
      get() {
        return this.getTraderMode;
      },
      set(val) {
        localStorage.setItem("trader-mode", val);
        this.setTraderMode(val);
        if (val && this.$route.name == 'Dashboard') {
          this.$router.push("/trader/dashboard");
          this.$apollo.queries.pendingConnections.startPolling(10000);
          return
        } 
        if (!val && this.$route.name == 'TraderDashboard') {
          this.$apollo.queries.pendingConnections.stopPolling();
          this.$router.push("/dashboard");
        }
      }
    },
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    items() {
      return this.$t("Layout.View.items");
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    this.traderMode = localStorage.getItem("trader-mode") === "true";
    this.setTraderMode(this.traderMode);
    if (this.traderMode == true)
      this.$apollo.queries.pendingConnections.startPolling(10000);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", [
      "setDrawer",
      "toggleDrawer",
      "setTraderMode",
      "setPendingRequests",
      "setShowChat"
    ]),
    onResponsiveInverted() {
      if (window.innerWidth < 1367) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    needHelp(){
      this.$tidioChatApi.track("need_help");
      this.setShowChat(true)
    },
    closeUpgradeDialog() {
      this.upgradeDialog = false
    }
  }
};
</script>

<style lang="scss">
#app-drawer {
  &.trader-bg {
    background-image: linear-gradient(166deg,  #091f81,  #081a6d);
  }
  &.user-bg {
    background-image: linear-gradient(166deg, #081a6d, #0b0224);
  }

  .v-image__image--contain {
    top: 16px;
    height: 60%;
  }

  div.v-responsive.v-image > div.v-responsive__content {
    overflow-y: auto;
  }
}
</style>
